<template>
    <MainContent title="Configuración de precios">
        <template v-slot:header v-if="pack">
            <b-col cols="12">
                <span class="h3">{{ pack.name }}</span>
                <div class="float-right">
                    <AddPriceModal 
                        @actualizar="getPrecios()"
                        :pack_id="pack.id"
                    />
                </div>                
            </b-col>
        </template>
        <template v-slot:content v-if="pack">
            <b-row>
                <b-col cols="12">
                    <b-table
                        v-if="precios.length > 0"
                        :items="precios"                        
                        :fields="fields"
                    >   
                        <template #cell(descripcion)="data">
                            <div v-html="data.item.description"></div>
                        </template>
                        <template #cell(price)="data">
                            {{ data.item.price | formatear_precio }} <small>(+{{ data.item.price_management | formatear_precio }} gastos de gestión)</small>
                        </template>
                        <template #cell(opciones)="{ item }">
                            <OpcionesDropdownComponent v-bind:options="[
                                { type: 'action', action:() => showModal('editar-precio-' + item.id), label: 'Editar'},
                                { type: 'action', action:() => showModal('borrar-precio-' + item.id), label: 'Borrar'}
                            ]"
                            />
                            <EditPriceModal 
                                @actualizar="getPrecios()"
                                :pack_id="pack.id"
                                :precio="item"
                            />
                            <BorrarModalComponent
                                :name="'borrar-precio-' + item.id"
                                :title="'Borrar precio ' + item.description"
                                confirmButton="¿Está segur@ de borrar este precio?"
                                v-on:close="() => closeModal()"
                                v-on:confirm="() => borrarPrecio(item.id)"
                            />
                        </template>                    
                    </b-table>
                    <b-alert
                        v-else 
                        show 
                        variant="warning"
                    >
                        No hay ningún precio en este pack
                    </b-alert>
                </b-col>
                <b-col cols="12">
                    <hr/>
                </b-col>
                <b-col cols="12" v-if="pack && pack.place_id">
                    <RegionesComponent
                        :pack_id="pack.id"
                        :precios="precios"
                    />
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent.vue'
    import AddPriceModal from '@/components/backend/pack-eventos/precios/modals/AddPriceModal.vue';
    import RegionesComponent from '@/components/backend/pack-eventos/precios/RegionesComponent.vue';
    import EditPriceModal from '@/components/backend/pack-eventos/precios/modals/EditPriceModal.vue';
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";
    import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";

    export default {
        props: ['pack_id'],
        data() {
            return {
                pack: null,
                precios: null,
                fields: [
                    { key: "description", label: "Descripción", class: 'text-center' },
                    { key: "price", label: "Precio", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        created() {
            this.getPack();
            this.getPrecios()
        },
        methods: {
            getPack() {
                const params = {
                    filters : {},
                    pack_id: this.pack_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show'), params).then(res => {
                    this.pack = res.data.data;
                });
            },
            getPrecios() {
                const params = {
                    filters : {},
                    pack_id: this.pack_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.prices'), params).then(res => {
                    this.precios = res.data.data;
                });
            },
            borrarPrecio(precio_id) {
                const params = {
                    filters : {},
                    pack_id: this.pack_id,
                    precio_id: precio_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.prices.delete'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getPrecios();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        components: {
            MainContent, AddPriceModal, RegionesComponent, EditPriceModal, BorrarModalComponent, OpcionesDropdownComponent
        }
    }
</script>